import { supabase } from '../lib/supabase';

export const contractService = {
  async getAll() {
    const { data, error } = await supabase?.from('employment_contracts')?.select(`
        *,
        employees (
          employee_number,
          first_name,
          last_name,
          department,
          position
        )
      `)?.order('created_at', { ascending: false });
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      employeeId: row?.employee_id,
      employee: row?.employees ? {
        employeeNumber: row?.employees?.employee_number,
        firstName: row?.employees?.first_name,
        lastName: row?.employees?.last_name,
        department: row?.employees?.department,
        position: row?.employees?.position
      } : null,
      contractType: row?.contract_type,
      contractStatus: row?.contract_status,
      startDate: row?.start_date,
      endDate: row?.end_date,
      baseSalary: row?.base_salary,
      hourlyRate: row?.hourly_rate,
      standardHours: row?.standard_hours,
      overtimeMultiplier: row?.overtime_multiplier,
      contractClauses: row?.contract_clauses,
      versionNumber: row?.version_number,
      createdAt: row?.created_at,
      updatedAt: row?.updated_at
    })) || [];
  },

  async getByEmployeeId(employeeId) {
    const { data, error } = await supabase?.from('employment_contracts')?.select('*')?.eq('employee_id', employeeId)?.order('version_number', { ascending: false });
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      contractType: row?.contract_type,
      contractStatus: row?.contract_status,
      startDate: row?.start_date,
      endDate: row?.end_date,
      baseSalary: row?.base_salary,
      hourlyRate: row?.hourly_rate,
      standardHours: row?.standard_hours,
      overtimeMultiplier: row?.overtime_multiplier,
      contractClauses: row?.contract_clauses,
      versionNumber: row?.version_number
    })) || [];
  },

  async create(contract) {
    const { data, error } = await supabase?.from('employment_contracts')?.insert({
        employee_id: contract?.employeeId,
        contract_type: contract?.contractType,
        contract_status: contract?.contractStatus || 'draft',
        start_date: contract?.startDate,
        end_date: contract?.endDate,
        base_salary: contract?.baseSalary,
        hourly_rate: contract?.hourlyRate,
        standard_hours: contract?.standardHours,
        overtime_multiplier: contract?.overtimeMultiplier || 1.5,
        contract_clauses: contract?.contractClauses
      })?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      employeeId: data?.employee_id,
      contractType: data?.contract_type,
      contractStatus: data?.contract_status,
      startDate: data?.start_date,
      endDate: data?.end_date,
      baseSalary: data?.base_salary,
      hourlyRate: data?.hourly_rate,
      versionNumber: data?.version_number,
      createdAt: data?.created_at
    };
  },

  async update(id, contract) {
    const { data, error } = await supabase?.from('employment_contracts')?.update({
        contract_status: contract?.contractStatus,
        base_salary: contract?.baseSalary,
        hourly_rate: contract?.hourlyRate,
        standard_hours: contract?.standardHours,
        overtime_multiplier: contract?.overtimeMultiplier,
        contract_clauses: contract?.contractClauses
      })?.eq('id', id)?.select()?.single();
    
    if (error) throw error;
    
    return {
      id: data?.id,
      contractStatus: data?.contract_status,
      baseSalary: data?.base_salary,
      hourlyRate: data?.hourly_rate,
      updatedAt: data?.updated_at
    };
  },

  async getActiveContracts() {
    const { data, error } = await supabase?.from('employment_contracts')?.select(`
        *,
        employees (
          employee_number,
          first_name,
          last_name,
          department
        )
      `)?.eq('contract_status', 'active');
    
    if (error) throw error;
    
    return data?.map(row => ({
      id: row?.id,
      employeeId: row?.employee_id,
      employee: row?.employees ? {
        employeeNumber: row?.employees?.employee_number,
        firstName: row?.employees?.first_name,
        lastName: row?.employees?.last_name,
        department: row?.employees?.department
      } : null,
      contractType: row?.contract_type,
      startDate: row?.start_date,
      endDate: row?.end_date,
      baseSalary: row?.base_salary
    })) || [];
  }
};

export default contractService;